<template>
  <div :class="`d-flex flex-column align-items-stretch gap-2`">
    <div class="d-flex flex-row w-100 gap-2">

      <!-- Image -->
      <ListThumbnail
        v-if="property.city?.imageCachingEnabled"
        :src="property.thumbnailUrl"
        :fallback-src="property.imageUrl"
      />
      <BImage v-else-if="property.imageUrl" :src="property.imageUrl" image-class="rounded" />

      <!-- Content -->
      <div class="d-flex flex-column flex-grow-1">
        <div class="fw-semibold">{{ normalizedAddress }}</div>
        <AssessorLink :property="property" class="small text-muted" />
        <div v-if="showOwners && owners.length > 0" class="small text-muted">
          <div v-for="owner in owners" :key="owner">{{ formatName(owner) }}</div>
        </div>
        <div v-if="showListingCount" class="text-muted small">
          {{ formatNumber(property.violations.activeListingCount, 'listing') }}
        </div>
      </div>

      <!-- Status -->
      <div class="d-flex flex-column align-items-end gap-0">
        <StatusBadge v-if="violationReason" variant="danger" class="mb-1">
          {{ violationReason }}
        </StatusBadge>
        <div v-if="property.violations.lastEvaluatedAt" class="text-muted small">
          Detected {{ toMoment(property.violations.lastEvaluatedAt).format('M/D/YY') }}
        </div>
        <PropertyIndicators :property="property" class="mt-auto" />
      </div>
    </div>
  </div>
</template>

<script>
import {Property} from "@/models/Property";
import ListThumbnail from "@/components/common/ListThumbnail.vue";
import BImage from "@/components/common/BImage.vue";
import AssessorLink from "@/components/common/AssessorLink.vue";
import PropertyIndicators from "@/components/properties/PropertyIndicators.vue";
import { normalizeAddressLines } from "@/addressFormatting";
import { formatDisplayName } from "@/nameFormatting";
import StatusBadge from "@/components/common/StatusBadge.vue";

export default {
  components: {
    StatusBadge,
    PropertyIndicators,
    AssessorLink,
    ListThumbnail,
    BImage
  },
  emits: ['edit'],
  props: {
    property: Property,
    showListingCount: Boolean,
    showOwners: Boolean
  },
  computed: {
    owners() {
      let owners = [];
      for (let owner of (this.property.owners || [])) {
        const formattedOwner = formatDisplayName(owner);
        if (!formattedOwner) {
          continue;
        }
        if (!owners.includes(formattedOwner)) {
          owners.push(formattedOwner);
        }
      }
      return owners;
    },
    normalizedAddress() {
      const rawAddress = this.property.addressFormatted;
      const [line1] = normalizeAddressLines(rawAddress);
      return line1 || rawAddress || 'Unknown address';
    },
    violationReason() {
      // TODO maybe store this in the violations object?
      const violations = this.property.violations;
      if (violations.status === 'violation') {
        if (violations.licenseStatus === 'none') {
          return 'Not licensed';
        } else if (violations.licenseStatus === 'expired') {
          return 'License expired';
        } else {
          return `License status: ${violations.licenseWorkflowStatus || 'unknown'}`
        }
      } else {
        return null;
      }
    }
  }
}
</script>
